import { renderChildren } from '@packages/react';

/**
 * IF React helper
 * @example
 * // Before
 * { a === true ? (
 *      <div>...</div>
 * ) : null }
 *
 * // After
 * { IF(a === true, (
 *      <div>...</div>
 * ))}
 *
 * @param condition
 * @param tElem
 * @param fElem
 * @returns {*}
 * @constructor
 */
export const IF = (condition: any, tElem: any, fElem: any = null): any =>
    !!condition ? renderChildren(tElem) : renderChildren(fElem);
